module.exports = "/_next/static/pages/testing-environment/766cc15c5935ac04fdf496880cba9ec8.png";